import React from "react";

import { WarningBannerContainer } from "./styles";
import PropType from "prop-types";

export default function WarningBanner(props) {
  if (props.active) {
    return (
      <WarningBannerContainer style={props.style}>
        {props.children}
      </WarningBannerContainer>
    );
  } else {
    return null;
  }
}

WarningBanner.propTypes = {
  children: PropType.node,
  active: PropType.bool,
};
